import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Home from "./pages/Home";
import Papers from "./pages/Papers";
import Projects from "./pages/Projects";
import Navigation from "./pages/Navigation";
import Unix from "./pages/Unix";

function App() {
  return (
    <div className="App">
      <Router>
        <Navigation />
        <Switch>
          <Route path="/" exact component={() => <Home />} />
          <Route path="/projects" exact component={() => <Projects />} />
          <Route path="/papers" exact component={() => <Papers />} />
          <Route path="/linux" exact component={() => <Unix />} />
          <Route path="/unix" exact component={() => <Unix />} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
